import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTournamentExpenses,
  getTournamentExpenseById,
  createTournamentExpense,
  updateTournamentExpense,
  deleteTournamentExpense,
} from "../../api/admin/tournamentExpenses.api";

/* ============================================================
   RESPONSE NORMALIZER
============================================================ */
const normalizeResponse = (res) => {
  let data = [];

  if (Array.isArray(res?.data)) {
    data = res.data;
  } else if (Array.isArray(res?.data?.data)) {
    data = res.data.data;
  }

  return {
    data,
    meta: {
      total: res?.count || data.length,
      total_pages: 1,
      page: 1,
      limit: data.length,
    },
  };
};

/* ============================================================
   FETCH EXPENSES
============================================================ */
export const fetchTournamentExpenses = createAsyncThunk(
  "admin/tournamentExpenses/fetch",
  async (
    { tournament_id = "" } = {},
    { rejectWithValue }
  ) => {
    try {
      const res = await getTournamentExpenses({
        tournament_id,
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return normalizeResponse(res);
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch expenses"
      );
    }
  }
);

/* ============================================================
   FETCH SINGLE EXPENSE
============================================================ */
export const fetchTournamentExpenseById = createAsyncThunk(
  "admin/tournamentExpenses/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getTournamentExpenseById(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch expense"
      );
    }
  }
);

/* ============================================================
   CREATE EXPENSE
============================================================ */
export const addTournamentExpense = createAsyncThunk(
  "admin/tournamentExpenses/add",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createTournamentExpense(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to create expense"
      );
    }
  }
);

/* ============================================================
   UPDATE EXPENSE
============================================================ */
export const updateTournamentExpenseThunk = createAsyncThunk(
  "admin/tournamentExpenses/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await updateTournamentExpense(id, payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        id,
        data: payload,
      };
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to update expense"
      );
    }
  }
);

/* ============================================================
   DELETE EXPENSE
============================================================ */
export const deleteTournamentExpenseThunk = createAsyncThunk(
  "admin/tournamentExpenses/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteTournamentExpense(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return id;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to delete expense"
      );
    }
  }
);